export interface KnobMaterial {
  id: string;
  name: string;
  displayName: string;
  useNodeMaterial?: boolean;
  nodeMaterialPath?: string;
  properties: {
    albedoColor: [number, number, number];
    metallic: number;
    roughness: number;
    environmentIntensity?: number;
    textureUrl?: string;
  };
  indicatorMaterial?: 'black' | 'white';
  childMeshMaterials?: {
    [meshName: string]: 'metallic' | 'black' | 'white';
  };
  childMeshNodeMaterials?: {
    [meshName: string]: {
      nodeMaterialPath: string;
    };
  };
}

export interface KnobType {
  id: string;
  name: string;
  displayName: string;
  modelPath: string;
  materials: KnobMaterial[];
}

export const SPECIAL_MATERIALS = {
  black: {
    id: 'special_black',
    name: 'special_black',
    displayName: 'Black Special',
    properties: {
      albedoColor: [0.02, 0.02, 0.02] as [number, number, number],
      metallic: 0.1,
      roughness: 0.1,
      environmentIntensity: 1.0
    }
  },
  white: {
    id: 'special_white', 
    name: 'special_white',
    displayName: 'White Special',
    properties: {
      albedoColor: [0.95, 0.95, 0.95] as [number, number, number],
      metallic: 0.1,
      roughness: 0.1,
      environmentIntensity: 1.0
    }
  },
  metallic: {
    id: 'special_metallic',
    name: 'special_metallic', 
    displayName: 'Metallic Face',
    properties: {
      albedoColor: [0.5, 0.5, 0.55] as [number, number, number],
      metallic: .9,
      roughness: 0.09,
      environmentIntensity: 7
    }
  }
} as const;

export const KNOB_CONFIGURATION: KnobType[] = [
  {
    id: 'vintage',
    name: 'vintage',
    displayName: 'Vintage',
    modelPath: '101.glb',
    materials: [
      {
        id: 'vintage_offwhite',
        name: 'offwhite',
        displayName: 'White',
        indicatorMaterial: 'black',
        useNodeMaterial: true,
        nodeMaterialPath: '/textures/Enclosures/Knob White Gloss.json',
        properties: {
          albedoColor: [0.92, 0.92, 0.92],
          metallic: .2,
          roughness: 0.02,
          environmentIntensity: 2
        }
      },
      {
        id: 'vintage_copper',
        name: 'copper',
        displayName: 'Black',
        indicatorMaterial: 'white',
        useNodeMaterial: true,
        nodeMaterialPath: '/textures/Enclosures/Knob Black Gloss.json',
        properties: {
          albedoColor: [0.92, 0.92, 0.92],
          metallic: .2,
          roughness: 0.02,
          environmentIntensity: .3        }
      },
      {
        id: 'vintage_steel',
        name: 'steel',
        displayName: 'Off-White',
        indicatorMaterial: 'black',
        useNodeMaterial: true,
        nodeMaterialPath: '/textures/Enclosures/Knob Cream Gloss.json',
        properties: {
          albedoColor: [0.92, 0.92, 0.92],
          metallic: .2,
          roughness: 0.02,
          environmentIntensity: 2
        }
      }
    ]
  },
  {
    id: 'classic',
    name: 'Classic',
    displayName: 'Davies',
    modelPath: 'fu.glb',
    materials: [
      {
        id: 'classic_black',
        name: 'black',
        displayName: 'White',
        indicatorMaterial: 'black',
        useNodeMaterial: true,
        nodeMaterialPath: '/textures/Enclosures/Knob White Gloss.json',
        properties: {
          albedoColor: [0.92, 0.92, 0.92],
          metallic: .2,
          roughness: 0.02,
          environmentIntensity: 2.1
        }
      },
      {
        id: 'classic_white',
        name: 'white',
        displayName: 'Black',
        indicatorMaterial: 'white',
        useNodeMaterial: true,
        nodeMaterialPath: '/textures/Enclosures/Knob Black Gloss.json',
        properties: {
          albedoColor: [0.92, 0.92, 0.92],
          metallic: .2,
          roughness: 0.02,
          environmentIntensity: .15
        }
      },
      {
        id: 'classic_silver',
        name: 'silver',
        displayName: 'Off-White',
        indicatorMaterial: 'black',
        useNodeMaterial: true,
        nodeMaterialPath: '/textures/Enclosures/Knob Cream Gloss.json',
        properties: {
          albedoColor: [0.92, 0.92, 0.92],
          metallic: .2,
          roughness: 0.02,
          environmentIntensity: 2
        }
      }
    ]
  }
]; 